import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';

import { BackendContainer } from '@/components/backend/BackendContainer';
import { useAbility } from '@/hooks/useAbility';
import { makeMetaTitle } from '@/modules/META';

function RouteComponent() {
  const { ability } = useAbility();

  if (!ability.can('MANAGE', 'SystemNotification')) return <Navigate to="/verwaltung" />;

  return (
    <BackendContainer>
      <Outlet />
    </BackendContainer>
  );
}

export const Route = createFileRoute('/verwaltung/_global/benachrichtigungen')({
  component: RouteComponent,
  head: () => ({
    meta: [makeMetaTitle(['Benachrichtigungen'])],
  }),
});
